module.exports = __webpack_public_path__ + "img/marketplace_black.3aea732a.svg";